import axios from 'axios'
import { useUserContext } from 'lib/context'
import { ActionpayAction, actionpayGoalIds } from 'lib/dto'

export const useYandexMetrica = () => {
  const {
    theme: { yandexMetrica },
  } = useUserContext()
  const ym =
    process.env.NODE_ENV === 'production' ? () => (window as any).ym as ym.Event : () => () => {}
  return [yandexMetrica?.id, ym] as const
}

type Goal =
  | `registration-${'filled-all-fields' | 'finished'}`
  | `moved-to-${'messenger' | 'youtube' | 'telegram-bot'}`
  | `landing-${
      | 'watched-video'
      | 'clicked-register'
      | 'clicked-register-header'
      | `clicked-register-${'wb' | 'ozon' | 'beru'}`
      | `use-cases-clicked-${2 | 3}`
      | `features-clicked-${2 | 3 | 4}`}`
  | `subscription-${'picked-retailer' | 'started-adding-card' | 'added-card' | 'paid'}`

export const useTrackGoal = () => {
  const [ymId, yandexMetrica] = useYandexMetrica()
  return (goalName: Goal) => {
    if (!ymId) return
    yandexMetrica()(ymId, 'reachGoal', goalName)
  }
}

export const trackActionpayActionServer = async (
  action: (typeof actionpayGoalIds)[ActionpayAction],
  actionId: string,
  price: number,
  cookies: Record<string, string>
) => {
  const actionpayCookie = cookies['actionpay']
  const utmSource = cookies['utm_source']

  if (utmSource !== 'actionpay' || process.env.NODE_ENV !== 'production') return

  return axios.get(
    `https://x.actionpay.ru/ok/${action}.png?actionpay=${actionpayCookie}&apid=${actionId}&price=${price}`
  )
}
